import { memo } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import "./FrequencyFlyersMarketing.scss";
import IconSkywards from "app/pages/.shared/IconSkywards";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const FrequencyFlyersMarketing = ({ showPictoOnly }) => {
	return (
		<div className="frequency-flyers-marketing">
			{!showPictoOnly && (
				<Typography variant={TYPOGRAPHY_VARIANTS.SMALL}>
					<FormattedMessage id="frequently.flyers.label" />
				</Typography>
			)}

			<div className="frequency-flyers-marketing__picto">
				<IconSkywards />
			</div>
		</div>
	);
};

FrequencyFlyersMarketing.propTypes = {
	showPictoOnly: PropTypes.bool,
};

export default memo(FrequencyFlyersMarketing);
